import React from 'react'
import { useIntl } from 'react-intl'
import { Checkbox } from '../checkbox'

interface Props {
  licensedOnly: boolean
  toggleLicensedOnly: () => void
  isGroupBySinkEnabled?: boolean
}

export const licensedOnlyCheckboxTestId = 'licensed-only-checkbox-test-id'

export function LicensedOnlyCheckbox({
  licensedOnly,
  toggleLicensedOnly,
  isGroupBySinkEnabled
}: Props) {
  const { formatMessage } = useIntl()
  return (
    <Checkbox
      onChange={() => toggleLicensedOnly()}
      disabled={isGroupBySinkEnabled}
      value={licensedOnly}
      label={formatMessage({
        id: 'description_vulnerabilities_showLicensedOnly'
      })}
      data-testid={licensedOnlyCheckboxTestId}
      data-e2e={licensedOnlyCheckboxTestId}
    />
  )
}
